export const FETCH_SURVEY_TEMPLATE_QUESTIONS_REQUEST = 'FETCH_SURVEY_TEMPLATE_QUESTIONS_REQUEST';
export const FETCH_SURVEY_TEMPLATE_QUESTIONS_SUCCESS = 'FETCH_SURVEY_TEMPLATE_QUESTIONS_SUCCESS';
export const FETCH_SURVEY_TEMPLATE_QUESTIONS_FAILURE = 'FETCH_SURVEY_TEMPLATE_QUESTIONS_FAILURE';

export const FETCH_SURVEY_TEMPLATE_QUESTION_REQUEST = 'FETCH_SURVEY_TEMPLATE_QUESTION_REQUEST';
export const FETCH_SURVEY_TEMPLATE_QUESTION_SUCCESS = 'FETCH_SURVEY_TEMPLATE_QUESTION_SUCCESS';
export const FETCH_SURVEY_TEMPLATE_QUESTION_FAILURE = 'FETCH_SURVEY_TEMPLATE_QUESTION_FAILURE';

export const CREATE_SURVEY_TEMPLATE_QUESTION_REQUEST = 'CREATE_SURVEY_TEMPLATE_QUESTION_REQUEST';
export const CREATE_SURVEY_TEMPLATE_QUESTION_SUCCESS = 'CREATE_SURVEY_TEMPLATE_QUESTION_SUCCESS';
export const CREATE_SURVEY_TEMPLATE_QUESTION_FAILURE = 'CREATE_SURVEY_TEMPLATE_QUESTION_FAILURE';

export const UPDATE_SURVEY_TEMPLATE_QUESTION_REQUEST = 'UPDATE_SURVEY_TEMPLATE_QUESTION_REQUEST';
export const UPDATE_SURVEY_TEMPLATE_QUESTION_SUCCESS = 'UPDATE_SURVEY_TEMPLATE_QUESTION_SUCCESS';
export const UPDATE_SURVEY_TEMPLATE_QUESTION_FAILURE = 'UPDATE_SURVEY_TEMPLATE_QUESTION_FAILURE';

export const DELETE_SURVEY_TEMPLATE_QUESTION_REQUEST = 'DELETE_SURVEY_TEMPLATE_QUESTION_REQUEST';
export const DELETE_SURVEY_TEMPLATE_QUESTION_SUCCESS = 'DELETE_SURVEY_TEMPLATE_QUESTION_SUCCESS';
export const DELETE_SURVEY_TEMPLATE_QUESTION_FAILURE = 'DELETE_SURVEY_TEMPLATE_QUESTION_FAILURE';

export const FETCH_SURVEY_TEMPLATE_QUESTIONS_OPTIONS_REQUEST = 'FETCH_SURVEY_TEMPLATE_QUESTIONS_OPTIONS_REQUEST';
export const FETCH_SURVEY_TEMPLATE_QUESTIONS_OPTIONS_SUCCESS = 'FETCH_SURVEY_TEMPLATE_QUESTIONS_OPTIONS_SUCCESS';
export const FETCH_SURVEY_TEMPLATE_QUESTIONS_OPTIONS_FAILURE = 'FETCH_SURVEY_TEMPLATE_QUESTIONS_OPTIONS_FAILURE';

export const DELETE_SURVEY_TEMPLATE_QUESTION_OPTIONS_REQUEST = 'DELETE_SURVEY_TEMPLATE_QUESTION_OPTIONS_REQUEST';
export const DELETE_SURVEY_TEMPLATE_QUESTION_OPTIONS_SUCCESS = 'DELETE_SURVEY_TEMPLATE_QUESTION_OPTIONS_SUCCESS';
export const DELETE_SURVEY_TEMPLATE_QUESTION_OPTIONS_FAILURE = 'DELETE_SURVEY_TEMPLATE_QUESTION_OPTIONS_FAILURE';